var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        visible: _vm.isOpen,
        width: "7.2rem",
        "append-to-body": "",
        "close-on-click-modal": false,
        "destroy-on-close": "",
        "custom-class": "extract-dialog",
      },
      on: {
        "update:visible": function ($event) {
          _vm.isOpen = $event
        },
      },
    },
    [
      _c(
        "div",
        { staticClass: "my-header", attrs: { slot: "title" }, slot: "title" },
        [
          _vm._v(
            "\n    " +
              _vm._s(_vm.type == "1" ? "Extract Tcash" : "Extract UNIT") +
              "\n  "
          ),
        ]
      ),
      _vm._v(" "),
      _c("div", [
        _c("div", { staticClass: "spaceLeft" }, [
          _c("div", { staticClass: "detail-title-2" }, [
            _vm._v("No. " + _vm._s(_vm.pageData.number)),
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "status",
              class: {
                "status-ing": _vm.pageData.status != 3,
                "status-over": _vm.isOver(_vm.pageData.overtime),
              },
            },
            [
              _vm._v(
                "\n        " +
                  _vm._s(
                    _vm.statusMap[
                      "status_" +
                        (_vm.isOver(_vm.pageData.overtime)
                          ? "3"
                          : _vm.pageData.status)
                    ]
                  )
              ),
            ]
          ),
        ]),
        _vm._v(" "),
        _c(
          "div",
          [
            _c("div", { staticClass: "detail-item spaceLeft" }, [
              _c("span", { staticClass: "detail-item-label" }, [
                _vm._v("Start time:"),
              ]),
              _vm._v(" "),
              _c("span", [
                _vm._v(
                  _vm._s(
                    _vm
                      .moment(_vm.pageData.timestamp)
                      .format("YYYY-MM-DD HH:mm:ss")
                  )
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "detail-item spaceLeft" }, [
              _c("span", { staticClass: "detail-item-label" }, [
                _vm._v(
                  "Closing time:\n          " +
                    _vm._s(
                      _vm
                        .moment(_vm.pageData.overtime)
                        .format("YYYY-MM-DD HH:mm:ss")
                    )
                ),
              ]),
            ]),
            _vm._v(" "),
            _vm.type == "1"
              ? [
                  _c("div", { staticClass: "detail-item spaceLeft" }, [
                    _c("span", { staticClass: "detail-item-label" }, [
                      _vm._v("Auction:"),
                    ]),
                    _vm._v(" "),
                    _c(
                      "span",
                      [
                        _c("big-number", {
                          attrs: { number: _vm.pageData.amount },
                        }),
                      ],
                      1
                    ),
                    _c("span", { staticClass: "unit" }, [_vm._v("UNIT")]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "detail-item spaceLeft" }, [
                    _c("span", { staticClass: "detail-item-label" }, [
                      _vm._v("My bid pric :"),
                    ]),
                    _vm._v(" "),
                    _c(
                      "span",
                      { staticClass: "big-num" },
                      [
                        _c("big-number", {
                          attrs: {
                            number:
                              _vm.pageData.auctiondetail &&
                              _vm.pageData.auctiondetail[0] &&
                              _vm.pageData.auctiondetail[0].amount,
                          },
                        }),
                      ],
                      1
                    ),
                    _c("span", { staticClass: "unit" }, [_vm._v("TCash")]),
                  ]),
                ]
              : _vm._e(),
            _vm._v(" "),
            _vm.type == "2"
              ? _c("div", { staticClass: "detail-item spaceLeft" }, [
                  _c("span", { staticClass: "detail-item-label" }, [
                    _vm._v("Auction :"),
                  ]),
                  _vm._v(" "),
                  _c(
                    "span",
                    { staticClass: "big-num" },
                    [
                      _c("big-number", {
                        attrs: { number: _vm.pageData.amount },
                      }),
                    ],
                    1
                  ),
                  _c("span", { staticClass: "unit" }, [_vm._v("UNIT")]),
                ])
              : _vm._e(),
          ],
          2
        ),
      ]),
      _vm._v(" "),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c("el-button", { on: { click: _vm.close } }, [_vm._v("Cancel")]),
          _vm._v(" "),
          _c("loading-btn", {
            attrs: { type: "primary", label: "Extract" },
            on: { clickHandle: _vm.save },
          }),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }